<script setup>
defineProps({
  remarks: { type: Array, default: () => [] },
});

defineOptions({ name: 'DetailRemarksCard' });

function author(remark) {
  return (
    remark.actor?.names ||
    remark.actor?.name ||
    remark.user_details?.names ||
    remark.user_details?.name ||
    remark.name ||
    'Unknown'
  );
}

function role(remark) {
  return remark.actor_role || remark.role || remark.user_role || '';
}

function timestamp(remark) {
  const value =
    remark.date_created ||
    remark.created_at ||
    remark.date ||
    remark.remark_date;
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

function label(remark) {
  return remark.status || remark.remark_type || remark.label || '';
}

function text(remark) {
  if (Array.isArray(remark.remarks)) return remark.remarks.join(' ').trim();
  return remark.remark || remark.text || remark.comment || '';
}
</script>

<template>
  <div>
    <div
      v-for="(remark, index) in remarks"
      :key="index"
      class="mb-2 border-b border-gray-100 pb-2 last:mb-0 last:border-0"
    >
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-900">
          {{ author(remark) }}
          <span v-if="role(remark)" class="font-normal text-gray-500">
            · {{ role(remark) }}
          </span>
        </span>
        <span v-if="timestamp(remark)" class="text-xs text-gray-400">{{
          timestamp(remark)
        }}</span>
      </div>
      <p
        v-if="label(remark)"
        class="mt-1 text-xs font-medium uppercase tracking-wide text-gray-500"
      >
        {{ label(remark) }}
      </p>
      <p class="text-sm text-gray-700">{{ text(remark) }}</p>
    </div>
  </div>
</template>
